import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function getPayPlanAssignment(locationId, planId) {
	const query = gql`
		query getPayPlanAssignment($locationId: String!, $planId: String) {
			getPayPlanAssignment(locationId: $locationId, planId: $planId) {
				_id
				fullName
			}
		}
	`;

	const variables = {
		locationId,
		planId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response?.data?.data?.getPayPlanAssignment;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function getUsersByPositionPayPlanAssignment(locationId, position) {
	const query = gql`
		query getUsers($locationId: String!, $filter: UserFilterInput) {
			getUsers(locationId: $locationId, filter: $filter) {
				_id
				locationId
				fullName
				position
				upcomingPayPlanAssignment {
					_id
					acknowledgementDate
					embeddedSigningLinks {
						url
						role
					}
					acknowledgementStatus {
						status
						statusDate
						statusMessage
						signingProgress {
							_id
							signedAt
							fullName
							roleId
						}
					}
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					planId {
						_id
						name
						position
					}
					effectiveDate
					position
				}
				currentPayPlanAssignment {
					_id
					acknowledgementDate
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					effectiveDate
					assignmentDate
					planId {
						_id
						name
						position
					}
					position
				}
			}
		}
	`;

	const variables = {
		locationId,
		filter: {
			locationId,
			position,
		},
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUsers;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function getUsersByPositionInputPayPlanAssignment(locationId, positionsInput) {
	const query = gql`
		query getUsers($locationId: String!, $filter: UserFilterInput) {
			getUsers(locationId: $locationId, filter: $filter) {
				_id
				locationId
				fullName
				position
				upcomingPayPlanAssignment {
					_id
					acknowledgementDate
					embeddedSigningLinks {
						url
						role
					}
					acknowledgementStatus {
						status
						statusDate
						statusMessage
						signingProgress {
							_id
							signedAt
							fullName
							roleId
						}
					}
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					planId {
						_id
						name
						position
					}
					effectiveDate
					position
				}
				currentPayPlanAssignment {
					_id
					acknowledgementDate
					acknowledgementDocumentLink
					assignedBy
					assignmentDate
					effectiveDate
					assignmentDate
					planId {
						_id
						name
						position
					}
					position
				}
			}
		}
	`;

	const variables = {
		locationId,
		filter: {
			locationId,
			positionsInput,
		},
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUsers;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export const getSupervisorsByPositionHierarchy = async (locationId, position) => {
	const query = gql`
		query getSupervisorsByPositionHierarchy($locationId: String!, $position: String!) {
			getSupervisorsByPositionHierarchy(locationId: $locationId, position: $position) {
				_id
				fullName
				position
			}
		}
	`;

	const variables = {
		locationId,
		position,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getSupervisorsByPositionHierarchy;
	} catch (err) {
		errorLogger(err);
		return null;
	}
};
